<template>
    <div>
      <invoiceHeader-list></invoiceHeader-list>
    </div>
  </template>
  
  <script>
  export default {};
  </script>
  